export const getItemColor = (done: boolean) =>
  done ? 'var(--primary)' : 'var(--darkgrey)'
